import { render, staticRenderFns } from "./ProcedureModelList.vue?vue&type=template&id=82ccc430&"
import script from "./ProcedureModelList.vue?vue&type=script&lang=js&"
export * from "./ProcedureModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports